import { call, all, put, takeLatest } from "redux-saga/effects";
import ActionType from "./constants";
import { getMMVDataSuccess, getMMVDataFailure } from "./actions";
import { fetchMMVData } from "./apis";
import { goToErrorPage } from "../indexModule/actions";

export function* getMMVData() {
  try {
    const mmv_version = sessionStorage?.getItem("mmv_version");
    const response = yield call(fetchMMVData, {
      mmv_version
    });
    const { popular_vehicles: popularVehicles, vehicles } = response.result;
    yield put(getMMVDataSuccess({ popularVehicles, vehicles }));
  } catch (err) {
    // yield put(errorLoadingPolicies(err));
    yield put(getMMVDataFailure(err));
    const { status } = typeof err === "object" ? err : { status: "" };
    yield put(goToErrorPage(status));
  }
}

function* mmvDataSaga() {
  yield all([takeLatest(ActionType.GET_MMV_DATA_REQUEST, getMMVData)]);
}

export default mmvDataSaga;
